/**
 * Binds a USPS COP `authorization_code` return to the browser tab that started
 * the connection (OAuth account-linking CSRF defense).
 *
 * The COP relay (CompleteUSPSOnboarding.aspx) only forwards `authorization_code`
 * back to the app, not an app-chosen nonce, so the binding is a single-use
 * marker kept in sessionStorage: set right before leaving for USPS, consumed
 * when the code is redeemed. A crafted link carrying an attacker's code, opened
 * in a tab that never clicked "Link Your Business Account", finds no marker and
 * the code is not exchanged.
 *
 * KEEP IN SYNC with React/app/src/lib/utils/uspsCopFlow.ts (same storage key,
 * window and semantics). The two stacks cannot share a module.
 */
const STORAGE_KEY = 'stamps.usps.copFlowStartedAt';

// Long enough for the USPS portal sign-in + T&C screens, short enough that an
// abandoned flow does not leave the marker armed.
const MAX_FLOW_AGE_MS = 15 * 60 * 1000;

export const markUspsCopFlowStarted = () => {
	sessionStorage.setItem(STORAGE_KEY, Date.now().toString());
};

/** Single-use: always clears the marker, returns true only if it was fresh. */
export const consumeUspsCopFlow = () => {
	const startedAt = Number(sessionStorage.getItem(STORAGE_KEY));
	sessionStorage.removeItem(STORAGE_KEY);
	const age = Date.now() - startedAt;
	return startedAt > 0 && age >= 0 && age <= MAX_FLOW_AGE_MS;
};
